<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row justify-content-center">
					<div class="col-lg-5">
						<span class="has-float-label">
							
						</span>
					</div>
				</div>
			</template>
		</CLoader>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:'Form',
    props:['NameList','poBtnSave'],
	data() {
		return {
			Modal:true,
			FormName:'sueldos',
			ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true,
            },
			ObjSueldo:{
				IdSueldo:0,
				Tipo:0,
				Cantidad:''
			},
			errorvalidacion:[]
		}
	},
	components:{
        Cbtnsave,
        Cvalidation
    },
	methods: {
		async Guardar(){
			this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			await this.$http.post(
                'sueldo/update',
                this.ObjSueldo
                ,
            ).then( (res) => {
                 this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#ModalForm').modal('hide');
                this.bus.$emit('List'); 

            }).catch( err => {
                this.poBtnSave.disableBtn=false;
                    if(err.response.data.type==2){
                           this.poBtnSave.toast=3; 
                            this.poBtnSave.toastmsg(err.response.data.message);
                    }else{
                       this.errorvalidacion=err.response.data.message.errores;
                        
                     this.poBtnSave.toast=2;  
                    }

            });
		},
		Limpiar(){
			this.ObjSueldo.IdSueldo=0;
			this.ObjSueldo.Tipo=0;
			this.ObjSueldo.Cantidad='';
			this.errorvalidacion=[];
		},
		get_one(){
			this.$http.get('sueldo/recovery',{
				params:{
					IdSueldo:this.ObjSueldo.IdSueldo
				}
			}).then((res) => {
				this.ObjSueldo=res.data.data.sueldo;
			})
		}
	},
	created() {
		this.bus.$off('Save');
        this.bus.$off('Nuevo');
		this.bus.$on('Save',()=>
        {
           this.Guardar();
        });
		this.bus.$on('Nuevo',(data,Id)=> 
        {   
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
            this.Limpiar();
            if (Id>0)
            {
                this.IdSueldo.IdSueldo=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit('Desbloqueo',false);
            
        });
	},
}
</script>

<style>

</style>
